// Community Maintenance Management APIs

/**
 * @function ApiClient#GetMaintenanceReportList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetMaintenanceReportList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/maintenance/reports?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

/**
 * @function ApiClient#AddMaintenanceReport
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} maintenanceReportData
 * @param {any} imageFiles
 * @param {any} options = {}
 */
export async function AddMaintenanceReport(cid, maintenanceReportData, imageFiles, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(maintenanceReportData));
  if (imageFiles) {
    imageFiles.forEach((f) => {
      formData.append("Image", f);
    });
  }
  return await this._post(`/community/${cid}/maintenance/report`, formData, options);
}

/**
 * @function ApiClient#GetMaintenanceReportResponseList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reportID
 * @param {any} options = {}
 */
export async function GetMaintenanceReportResponseList(cid, reportID, options = {}) {
  return await this._get(`/community/${cid}/maintenance/report/${reportID}/response`, options);
}

/**
 * @function ApiClient#UpdateMaintenanceReport
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reportID
 * @param {any} updateData
 * @param {any} options = {}
 */
export async function UpdateMaintenanceReport(cid, reportID, updateData, options = {}) {
  return await this._post(`/community/${cid}/maintenance/report/${reportID}`, updateData, options);
}

// Work Order APIs

/**
 * @function ApiClient#SearchMaintenanceWorkOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} ss
 * @param {any} options = {}
 */
export async function SearchMaintenanceWorkOrder(cid, ss, options = {}) {
  return await this._get(`/community/${cid}/maintenance/work_order/search?ss=${ss}`, options);
}

/**
 * @function ApiClient#AddMaintenanceWorkOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddMaintenanceWorkOrder(cid, data, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(data));
  return await this._post(`/community/${cid}/maintenance/work_order`, formData, options);
}

/**
 * @function ApiClient#GetMaintenanceWorkOrderList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetMaintenanceWorkOrderList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/maintenance/work_orders?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

// Contract APIs

/**
 * @function ApiClient#GetMaintenanceContractList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetMaintenanceContractList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/maintenance/contracts?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

/**
 * @function ApiClient#AddMaintenanceContract
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} contractData
 * @param {any} files
 * @param {any} options = {}
 */
export async function AddMaintenanceContract(cid, contractData, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(contractData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  return await this._post(`/community/${cid}/maintenance/contract`, formData, options);
}

/**
 * @function ApiClient#UpdateMaintenanceContract
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} contractData
 * @param {any} files
 * @param {any} options = {}
 */
export async function UpdateMaintenanceContract(cid, contractData, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(contractData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  return await this._put(`/community/${cid}/maintenance/contract/${contractData.ID}`, formData, options);
}

/**
 * @function ApiClient#GetMaintenanceContractLogList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} contractId
 * @param {any} options = {}
 */
export async function GetMaintenanceContractLogList(cid, contractId, options = {}) {
  return await this._get(`/community/${cid}/maintenance/contract/${contractId}/log`, options);
}
